export const ItemDetailsSummary = ({ item, prefix }) => {
  const sizes = Object.entries(item.size_quantities || {});
  if (!sizes.length && !item.details) return null;
  return (
    <div className="mt-2 min-w-0 space-y-1 text-xs leading-relaxed [overflow-wrap:anywhere]">
      {!!sizes.length && <p data-testid={`${prefix}-sizes`} className="text-cyan-300">Sizes: {sizes.map(([size, qty]) => `${size} × ${qty}`).join(" · ")}</p>}
      {item.details && <p data-testid={`${prefix}-details`} className="whitespace-pre-wrap text-slate-300"><span className="font-semibold text-slate-400">Product details: </span>{item.details}</p>}
    </div>
  );
};